import { Platform } from "react-native";
const isWeb = Platform.OS === "web";
const isAndroid = Platform.OS === "android";
const isIOS = Platform.OS === "ios";
// TODO: Maybe this could be a bundler global instead.
/** @returns `true` when the current JS running in a DOM Component environment. */
export const IS_DOM = false;
export { isWeb, isAndroid, isIOS };
